import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Divider, SubheaderBlock } from '@fs/zion-ui'
import { css } from '@emotion/core'
import AdvancedSearchCardImg from './AdvancedSearchCard.svg'
import sendAnalytics from '../../services/analytics-helper'

const cardCss = css`
  height: 480px;
  width: 300px;
  background: #f7f8f8;
  border-radius: 5px;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
`

const upperCss = css`
  height: 140px;
  background: white;
  background-image: url(${AdvancedSearchCardImg});
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const lowerCss = css`
  padding: 10px 20px;
`

const topSectionSpacing = css`
  padding-top: 5px;
  padding-bottom: 8px;

  button {
    margin-left: -10px;
  }
`
const bottomSectionPadding = css`
  padding-top: 10px;

  button {
    margin-left: -10px;
  }
`

export default function AdvancedSearchCard({ treeFindUrl }: { treeFindUrl: string }): JSX.Element {
  const [t] = useTranslation()
  const headerText = t(
    'ancestors.advanced-search-card.header',
    'Not finding what you are looking for in the quick search?'
  )
  const subHeaderText = t(
    'ancestors.advanced-search-card.subheader',
    'Try the advanced search to find more results about your ancestors.'
  )
  const livingText = t(
    'ancestors.advanced-search-card.living.text',
    'Search for a deceased person. Information about living people is limited for privacy reasons.'
  )

  return (
    <div css={cardCss}>
      <div css={upperCss} />
      <div css={lowerCss}>
        <div css={topSectionSpacing}>
          <SubheaderBlock size="md" heading={headerText} />
          <SubheaderBlock size="md" heading="" subHeading={subHeaderText} />
          <Button
            data-testid="go-to-tree-find"
            emphasis="low"
            external
            to={treeFindUrl}
            onClick={() => {
              sendAnalytics({ link_page: 'Search', link_name: 'Family Tree Search' })
            }}
          >
            {t('ancestors.family-tree-search.action', 'Family Tree Search')}
          </Button>
        </div>
        <Divider />
        <div css={bottomSectionPadding}>
          <SubheaderBlock size="md" heading="" subHeading={livingText} />
          <Button
            data-testid="go-help-private-spaces"
            emphasis="inline"
            external
            to="https://www.familysearch.org/help/helpcenter/article/what-is-a-private-space-in-family-tree"
            onClick={() => {
              sendAnalytics({ link_page: 'Search', link_name: 'Learn More' })
            }}
          >
            {t('common-ui:learn-more.action', 'Learn More')}
          </Button>
        </div>
      </div>
    </div>
  )
}
